/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddAddressRequest } from '../models/AddAddressRequest';
import type { AddAddressResponse } from '../models/AddAddressResponse';
import type { ChangePasswordRequest } from '../models/ChangePasswordRequest';
import type { CommonResponse } from '../models/CommonResponse';
import type { DeleteAddressRequest } from '../models/DeleteAddressRequest';
import type { GetUserInfoResponse } from '../models/GetUserInfoResponse';
import type { ListAddressesResponse } from '../models/ListAddressesResponse';
import type { SetDefaultAddressRequest } from '../models/SetDefaultAddressRequest';
import type { UpdateAddressRequest } from '../models/UpdateAddressRequest';
import type { UpdateMemberInfoRequest } from '../models/UpdateMemberInfoRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MemberService {
	/**
	 * @returns CommonResponse A successful response.
	 * @throws ApiError
	 */
	public static logout(): CancelablePromise<CommonResponse> {
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/auth/logout',
		});
	}
	/**
	 * @returns ListAddressesResponse A successful response.
	 * @throws ApiError
	 */
	public static listAddresses(): CancelablePromise<ListAddressesResponse> {
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/member/addresses',
		});
	}
	/**
	 * @returns AddAddressResponse A successful response.
	 * @throws ApiError
	 */
	public static addAddress({
		body,
	}: {
		body: AddAddressRequest;
	}): CancelablePromise<AddAddressResponse> {
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/member/addresses',
			body: body,
		});
	}
	/**
	 * @returns CommonResponse A successful response.
	 * @throws ApiError
	 */
	public static deleteAddress({
		addressId,
		body,
	}: {
		addressId: string;
		body: DeleteAddressRequest;
	}): CancelablePromise<CommonResponse> {
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/v1/member/addresses/{addressId}',
			path: {
				addressId: addressId,
			},
			body: body,
		});
	}
	/**
	 * @returns CommonResponse A successful response.
	 * @throws ApiError
	 */
	public static updateAddress({
		addressId,
		body,
	}: {
		addressId: string;
		body: UpdateAddressRequest;
	}): CancelablePromise<CommonResponse> {
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/member/addresses/{addressId}',
			path: {
				addressId: addressId,
			},
			body: body,
		});
	}
	/**
	 * @returns CommonResponse A successful response.
	 * @throws ApiError
	 */
	public static setDefaultAddress({
		addressId,
		body,
	}: {
		addressId: string;
		body: SetDefaultAddressRequest;
	}): CancelablePromise<CommonResponse> {
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/member/addresses/{addressId}/default',
			path: {
				addressId: addressId,
			},
			body: body,
		});
	}
	/**
	 * @returns CommonResponse A successful response.
	 * @throws ApiError
	 */
	public static changePassword({
		body,
	}: {
		body: ChangePasswordRequest;
	}): CancelablePromise<CommonResponse> {
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/member/change-password',
			body: body,
		});
	}
	/**
	 * @returns GetUserInfoResponse A successful response.
	 * @throws ApiError
	 */
	public static currentMember(): CancelablePromise<GetUserInfoResponse> {
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/v1/member/current-member',
		});
	}
	/**
	 * @returns CommonResponse A successful response.
	 * @throws ApiError
	 */
	public static updateMemberInfo({
		body,
	}: {
		body: UpdateMemberInfoRequest;
	}): CancelablePromise<CommonResponse> {
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/member/info',
			body: body,
		});
	}
	public static updateMemberMerchant({ body }: { body: any }) {
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/v1/member/merchant',
			body: body,
		});
	}
	public static forgetPassword({ body }: { body: any }) {
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/v1/auth/forget-password',
			body: body,
		});
	}
}
